class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    
    this.elements = {
      input: this.querySelector("input[name='language_code'], input[name='country_code']"),
      select: this.querySelector(".countries"),
      icon: this.querySelector(".localization--icon-current"),
    };

    this.querySelector(".localization__submit")?.addEventListener("click", this.onSubmit.bind(this));
    this.elements.select?.addEventListener("change", this.onSelectChange.bind(this));

    //If the user selects an external store and hits Back button, the wrong value will be populated due to Back-Forward Caching (bfcache)
    //The Liquid will load the correct flag icon, but the text will still say the external store name, potentially confusing the user as to what store they are on
    document.addEventListener("readystatechange", (e) => {

      //Wait for page load to be complete, and then force a change event to ensure the text updates as well
      if(document.readyState === "complete") {
        const actualValue = this.querySelector("option[selected='selected']").value;
        this.elements.select.value = actualValue;

        const changeEvent = new Event("change", { bubbles: true });
        this.elements.select.dispatchEvent(changeEvent);
      }
    });
  }

  onSubmit(event) {

    //On click, prevent form submit until hidden <input/> element's value is populated
    //Otherwise, new country will NOT go through {% form "localization" %} correctly.
    event.preventDefault();

    const optionExternalURL = this.querySelector(`option[value=${this.elements.select?.value}]`)?.dataset.href;

    //Check if country selected is local or external
    if(optionExternalURL != "local") {

      //If external - redirect
      window.location.href = optionExternalURL;
    }
    //Else, set value and submit form
    else {
      const form = this.querySelector("form");
      this.elements.input.value = this.elements.select?.value;

      if(form) form.submit();
    }
  }

  //When the <select> changes
  onSelectChange(event) {

    //Format new src url
    const newCountry = this.elements.select.value.toLowerCase();
    const iconSrcSplit = this.elements.icon?.src.split("flags/");

    const newIconSrc = `${iconSrcSplit[0]}flags/${newCountry}.svg?width=22`

    //Update flag icon
    this.elements.icon.src = newIconSrc;
  }
}

customElements.define("localization-form", LocalizationForm);